var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-form',{ref:"form"},[_c('v-card-text',[_c('v-row',[_c('v-col',[_c('v-text-field',{attrs:{"filled":"","hide-details":"auto","label":_vm.$t('title'),"rules":[ _vm.rules.required ]},model:{value:(_vm.learningTenant.title),callback:function ($$v) {_vm.$set(_vm.learningTenant, "title", $$v)},expression:"learningTenant.title"}})],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }